// Notes:
import "intersection-observer";

export default function(box) {

  // positions
  let previousY = 0;
  let previousRatio = 0;

  // do animations
  const Observations = (entries) => {
    entries.forEach(entry => {
      // - Settings
      // -- Current
      const currentY = entry.boundingClientRect.y;
      const currentRatio = entry.intersectionRatio;

      // -- Check type
      if(entry.target.classList.contains('step--parent')) {
        var elementClass = '-play-parent'
      } else {
        var elementClass = '-play'
      }

      // In/Out
      if (entry.isIntersecting) {
        // Step (active)
        entry.target.classList.add(elementClass);
      } else {
        // Step (inactive)
        entry.target.classList.remove(elementClass);
      }

      previousY = currentY;
      previousRatio = currentRatio;

    });
  };

  // create the observer
  const options = {
    threshold: .2
  };
  const observer = new IntersectionObserver(Observations, options);

  // add the observer
  observer.observe(box)

}
